// Module
var code = `<div class="application-panel-container-table">
    <terceraPanel name='windowPanelBodyQT' />
</div>`;
// Exports
export default code;